class ComponentProductCard extends HTMLElement {
  constructor() {
    super()
    this.quickViewBtn = this.querySelector('.quick-view-trigger')
    this.swatches = this.querySelector('.inline-swatch-group')
    if(this.quickViewBtn)
      this.quickViewBtn.addEventListener('click', this.openQuickView.bind(this))
    if(this.swatches)
      this.swatches.querySelectorAll('input').forEach((input)=>{
        input.addEventListener('change', this.onSwatchChange.bind(this))
      })
  }

  openQuickView(e) {
    e.preventDefault()
    $s.showLoadingOverlay();
    var qvUrl = this.quickViewBtn.dataset.url;
    //qvUrl += (qvUrl.indexOf('?')>0 ? '&' : '?') + 'sections=product_main';
    $s.get({
      url: qvUrl,
      success: (data)=>{
        var doc, 
            productMainSection,
            productEligibleStatesSection,
            popupContent;
        if (typeof(data) == "string") {
          var parser = new DOMParser();
          doc = parser.parseFromString(data, 'text/html');
        } else {
          doc = data;
        }
        productMainSection = doc.querySelector('product-main').closest('.shopify-section');
        productEligibleStatesSection = doc.querySelector('.eligible-states').closest('.shopify-section');

        popupContent = document.createElement("div");
        popupContent.appendChild(productMainSection);
        popupContent.appendChild(productEligibleStatesSection);

        $s.openModal(popupContent, 'product-quick-view');
        $s.globalEval(popupContent);
        this.initCardAccordion();
      },
      always: (data)=>{
        $s.hideLoadingOverlay();
      }
    })
  }

  onSwatchChange() {
    var checkedOption = this.querySelector('.inline-swatch-group input:checked')
    var variantImg = checkedOption.dataset.variantImg
    var variantUrl = checkedOption.dataset.variantUrl
    var priceFinal = checkedOption.dataset.priceFinal
    var priceCompare = checkedOption.dataset.priceCompare

    this.querySelector('.product-card-url').setAttribute('href', variantUrl)
    if (this.quickViewBtn)
      this.quickViewBtn.setAttribute('data-url', variantUrl)
    this.querySelector('.final').innerHTML = priceFinal
    if(this.querySelector('.from')) {
      this.querySelector('.from').style.display = "none"
    }
    if(priceCompare) {
      this.querySelector('.compare').innerHTML = priceCompare
      this.querySelector('.compare').style.display = "block"
    } else {
      this.querySelector('.compare').style.display = "none"
    }
    if(variantImg) {
      this.querySelector('.img.main').setAttribute('srcset', variantImg)
    }
  }

  initCardAccordion() {
    const triger = document.querySelector('.subscription-product--main__selector-triger');
    const categories = document.querySelector('.subscription-product--main__selector-list');
    let flag = false;

    triger &&
      triger.addEventListener('click', ({ currentTarget }) => {
      if (!currentTarget.classList.contains('open')) {
        categories.style.height = categories.scrollHeight + 'px';
      } else {
        categories.style.height = 0;
      }

      flag = !flag

      triger.classList.toggle('open');
      categories.classList.toggle('open');
      triger.setAttribute('aria-expanded', flag);
      categories.setAttribute('aria-hidden', !flag);
    });
  }
}
customElements.define('product-card', ComponentProductCard);
